module.exports = __webpack_public_path__ + "img/baseMarker.5eae2210.png";